const hasProtocol = (value: string): boolean => /^https?:\/\//i.test(value);

type NormalizeExternalUrlOptions = {
  /**
   * Used when the input omits a protocol. Defaults to `https`.
   *
   * Example: `example.com` -> `https://example.com/`
   */
  defaultProtocol?: 'https' | 'http';
};

export const normalizeExternalUrl = (
  value: string,
  options?: NormalizeExternalUrlOptions,
): string | null => {
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return null;
  }

  const defaultProtocol = options?.defaultProtocol ?? 'https';
  const urlWithProtocol = hasProtocol(trimmedValue)
    ? trimmedValue
    : `${defaultProtocol}://${trimmedValue}`;

  try {
    return new URL(urlWithProtocol).href;
  } catch {
    return null;
  }
};

export const isValidExternalUrl = (value: string): boolean => normalizeExternalUrl(value) !== null;

export const EXTERNAL_URL_PATTERN =
  /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/i;

export const isValidHttpUrl = (value: string): boolean => {
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};
